import { CurrentViewContextProvider } from "@/domain/view/hooks/use-current-view-context";

import { DatatableRowData, defaultDatatableState } from "../datatable-types";

import { type InternalDataTableContextProviderProps } from "./datatable-context-props";
import { PrepareInitialContextWithAPIState } from "./prepare-initial-context-with-api-state";
import { PrepareInitialContextWithUrlParams } from "./prepare-initial-context-with-url-params";

export const PrepareInitialContextWithViewProvider = <TData extends DatatableRowData>(
  props: InternalDataTableContextProviderProps<TData>,
) => {
  if (props.synchToApi) {
    return (
      <CurrentViewContextProvider
        viewKey={props.viewKey}
        workspaceId={props.workspaceId}
        baseDatatableState={props.initialState}
      >
        <PrepareInitialContextWithAPIState {...props} />
      </CurrentViewContextProvider>
    );
  }

  return (
    <PrepareInitialContextWithUrlParams
      {...props}
      initialState={props.initialState ?? defaultDatatableState}
      saveDatatableState={() => {}}
    />
  );
};
